import * as React from 'react';
import { baseClassName } from '../styles/index.js';

const Description = ({ value  })=>/*#__PURE__*/ React.createElement("p", {
        className: `${baseClassName}__description`
    }, value)
;

export { Description };
//# sourceMappingURL=Description.js.map
